goog.provide("shadow.js.shim.module$src$svg$controls$media_player_call$volume_wave_2_svg$default");
shadow.js.shim.module$src$svg$controls$media_player_call$volume_wave_2_svg$default = shadow.js.shim.module$src$svg$controls$media_player_call$volume_wave_2_svg.default;
